import { useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faFlask } from '@fortawesome/free-solid-svg-icons'
import NewSample from 'transactions/table/new-sample'
import SampleCard from './sample-card'
import MutedText from 'shared/forms/muted-text'

const SampleList = ({ samples, isLoading, dashboardId, params, canEdit, onSelectSample, onSampleCreated }) => {
  const [showNewSample, setShowNewSample] = useState(false)

  return (
    <>
      <Row className="mb-3 align-items-center">
        <Col>
          <h5 className="mb-0">Samples</h5>
        </Col>
        {canEdit && (
          <Col sm="auto">
            <Button
              variant="primary"
              size="sm"
              onClick={() => setShowNewSample(true)}
            >
              <FontAwesomeIcon icon={faPlus} className="me-1" />
              New Sample
            </Button>
          </Col>
        )}
      </Row>

      {isLoading && (
        <div className="text-center py-5">
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      {!isLoading && samples && samples.length === 0 && (
        <div className="text-center py-5">
          <FontAwesomeIcon icon={faFlask} size="2x" className="text-muted mb-3" />
          <div className="h6 mb-2">No Samples Yet</div>
          <MutedText as="div" lighter className="mb-3">
            Create a sample to begin reviewing transactions from this view.
          </MutedText>
          {canEdit && (
            <Button
              variant="primary"
              size="sm"
              onClick={() => setShowNewSample(true)}
            >
              <FontAwesomeIcon icon={faPlus} className="me-1" />
              New Sample
            </Button>
          )}
        </div>
      )}

      {!isLoading && samples && samples.length > 0 && (
        <Row>
          {samples.map((sample) => (
            <Col key={`sample-card-${sample.id}`} xs={12} md={6} lg={4}>
              <SampleCard sample={sample} onClick={onSelectSample} />
            </Col>
          ))}
        </Row>
      )}

      {canEdit && (
        <NewSample
          show={showNewSample}
          setShow={setShowNewSample}
          params={params}
          onCreated={onSampleCreated}
        />
      )}
    </>
  )
}

export default SampleList
